import { getCurrentWindow } from "@tauri-apps/api/window";
import { isTauri } from "@/lib/is-tauri";

/** Only work-area overlays own native workspace geometry and Spaces policy. */
export function isDesktopOverlayLabel(label: string): boolean {
  if (label === "main") return true;
  const match = /^display-([0-9]+)$/.exec(label);
  return match !== null && match[0] === label && Number(match[1]) <= 0xffffffff;
}

export function isDesktopOverlayWindow(): boolean {
  return isTauri() && isDesktopOverlayLabel(getCurrentWindow().label);
}
